// A context so consumers can know which table "section" they are in (i.e.,
// thead, tbody, or tfoot).
import { createContext } from "react";
const TableSectionContext = /*#__PURE__*/createContext();
export default TableSectionContext;